import { IApplicationState } from '../../types/redux';

export const selectOffersCount = (state: IApplicationState): number | null => {
  return state.filters.offersCount.count;
};
